import axiosInstance from '../helpers/axiosInstance';

export const getProductApi = async (request) => {
    const response = await axiosInstance.post('staff/productsList', request.data);
    return response.data;
};

export const createProductApi = async (request) => {
    const response = await axiosInstance.post('staff/products', request);
    return response.data;
};

export const getProductUnitApi = async () => {
    const response = await axiosInstance.get('public/dropdown/units');
    return response.data;
};

export const getProductByIdApi = async (productId) => {
    const response = await axiosInstance.get(`staff/products/${productId}`);
    return response.data;
};

export const updateProductApi = async (request) => {
    const response = await axiosInstance.put('staff/products', request);
    return response.data;
};

export const getProductHistoryApi = async (productId) => {
    const response = await axiosInstance.get(`staff/products/${productId}/priceHistory`);
    return response.data;
};

// productType is optional — omitted the API defaults to the STATIC catalogue.
// Pass "PACKAGE" to list the package mirror products instead.
export const getBulkProductsApi = async (searchKey, productType) => {
    const typeParam = productType ? `&productType=${productType}` : "";
    const response = await axiosInstance.get(`staff/products?sizeOfPage=50&searchKey=${searchKey}${typeParam}`);
    return response.data;
};

export const createStockApi = async (request) => {
    const response = await axiosInstance.post('staff/products/stock', request);
    return response.data;
};

export const getProductCsvDownloadApi = async () => {
    const response = await axiosInstance.get('staff/product/purchaseDetail/csv', {
        responseType: 'text',
    });
    return response.data;
};

export const getBulkCsvDownloadApi = async () => {
    const response = await axiosInstance.get('staff/product/productList/csv', {
        responseType: 'text',
    });
    return response.data;
};

export const bulkProductStatusApi = async (request) => {
    const response = await axiosInstance.put('staff/products/bulk-status', request);
    return response.data;
};

export const updateBulkTableApi = async (request) => {
    const response = await axiosInstance.put('staff/product/updatePrice', request);
    return response.data;
};
